import React, { useRef, useState } from 'react'
import { Cropper } from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import PrimaryButton from '../Button/PrimaryButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/free-solid-svg-icons'

const ImageInput = ({
  name,
  label,
  required,
  maxFileSize = 5242880,
  allowedFileType = ['image/png', 'image/jpg', 'image/jpeg'],
  aspectRatio = 0.75 / 1,
}) => {
  const inputRef = useRef()
  const cropperRef = useRef()
  const [modal, setModal] = useState(false)
  const [currentImage, setCurrentImage] = useState('')

  const onChange = (event) => {
    let file = null
    if (event.target.files && event.target.files.length === 1) {
      file = event.target.files[0]
    }
    if (file === null) {
      return
    }
    if (file.size > maxFileSize) {
      inputRef.current.value = null
      alert('File terlalu besar')
      return
    }
    if (!allowedFileType.includes(file.type)) {
      inputRef.current.value = null
      alert('Tipe file salah')
      return
    }
    setCurrentImage(URL.createObjectURL(file))
    setModal(true)
  }

  const onCancel = () => {
    inputRef.current.value = null
    setCurrentImage('')
    setModal(false)
  }

  const onSave = () => {
    if (typeof cropperRef.current?.cropper !== 'undefined') {
      cropperRef.current?.cropper.getCroppedCanvas().toBlob((blob) => {
        const dataTransfer = new DataTransfer()
        const file = new File([blob], 'profile.png', {
          type: 'image/png',
        })
        dataTransfer.items.add(file)
        inputRef.current.files = dataTransfer.files
        setCurrentImage(
          cropperRef.current?.cropper.getCroppedCanvas().toDataURL(),
        )
        setModal(false)
      })
    }
  }

  return (
    <>
      <div className={`modal ${modal && 'modal-open'}`}>
        <div className="modal-box">
          <Cropper
            className="w-full h-[400px]"
            ref={cropperRef}
            src={currentImage}
            aspectRatio={aspectRatio}
            guides
          />
          <div className="flex justify-end gap-2 mt-4">
            <PrimaryButton onClick={onCancel}>Batal</PrimaryButton>
            <PrimaryButton onClick={onSave}>Simpan</PrimaryButton>
          </div>
        </div>
      </div>
      <div className="relative">
        <img
          src={currentImage === '' ? '/avatar-placeholder.png' : currentImage}
          className="w-[100px] h-[120px] rounded-lg"
        />
        <button
          type="button"
          aria-label="Ubah foto"
          className="absolute -bottom-3 -right-3 w-9 h-9 rounded-full bg-white border border-line shadow-card text-ink flex items-center justify-center cursor-pointer"
          onClick={() => inputRef.current.click()}
        >
          <FontAwesomeIcon icon={faCamera} className="text-sm" />
        </button>
        <input
          type="file"
          className="hidden"
          name={name}
          aria-label={label}
          ref={inputRef}
          onChange={onChange}
          required={required}
        />
      </div>
    </>
  )
}

export default ImageInput
